'use client';

import { motion, AnimatePresence } from 'framer-motion';

interface PolicyModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    url: string;
}

export function PolicyModal({ isOpen, onClose, title, url }: PolicyModalProps) {
    const handleClose = () => {
        onClose();
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={handleClose}
                >
                    <motion.div
                        className="bg-white rounded-2xl w-full h-[80vh] flex flex-col overflow-hidden"
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.9, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        onClick={(e: React.MouseEvent) => e.stopPropagation()}
                    >
                        {/* Header with close button */}
                        <div className="bg-gray-100 px-6 py-4 flex items-center justify-between border-b">
                            <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
                            <button
                                onClick={handleClose}
                                className="p-2 hover:bg-gray-200 rounded-lg transition-colors"
                                aria-label="Close"
                            >
                                <svg
                                    className="w-6 h-6 text-gray-600"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </button>
                        </div>

                        {/* Iframe content */}
                        <div className="flex-1 overflow-hidden">
                            <iframe
                                src={url}
                                title={title}
                                className="w-full h-full border-0"
                                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                            />
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
